import { TeamVersionsEnum } from "@app/model/app/passwordGroup/TeamVersionsEnum";
import { BaseResponse } from "../BaseResponse";

export class UpdateTeamRequest extends BaseResponse {
    id: number;
    data: string = '';
    version: number = TeamVersionsEnum.V2;
    defaultRoleForGroupMembers: number = 0;
}